import { makeSelectors } from '@utils/css';
import { row } from './row.style.js';

const bodyCrossfadeDurationMs = 200;
const rowTransitionDurationMs = 250;
const table = "dibt18egu5c";
const headerGroup = "dibh7k0kb9";
const tableBody = "dibtxxib68";
const transitionWrapper = "dibt1xvk78h";
const transitionableRow = "dibt1wlz4qu";
const emptyMessage = "dibe9hrha8";
const tableSelectors = makeSelectors({
  table,
  headerGroup,
  body: tableBody,
  chunk: "dibc1x2c7yg",
  rowWrapper: transitionableRow,
  row
});

export { bodyCrossfadeDurationMs, emptyMessage, headerGroup, rowTransitionDurationMs, table, tableBody, tableSelectors, transitionWrapper, transitionableRow };
import "./table.style.linaria.module.css";
//# sourceMappingURL=table.style.js.map
